// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/pirep-decode.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/pirep-decode/pirep-decode.js';

mount([g0]);
